<!-- eslint-disable -->
<template>
	<div>
		<div class="d-flex mx-auto mt-4" style="max-width: 360px;height: 160px;"> 
			<img class="image-fit" src="@/assets/images/img_locker_cancel.png" alt="locker_cancel" style="width: 100%;"/>
		</div>
		
		<div class="m-auto text-center" style="width: 100%;"> 
			<div class="text-center px-4" > 
				<div class="text-gotham-bold text-18 pt-4 pb-2">{{ title }}</div>
				<div class="text-14" style="color:#929293">{{ description }}</div>
			</div>
		</div>

		<div style="bottom:0;position: absolute;width: 100%;" class="p-4">
			<button
					@click="$router.go(-1)"
					class="button rounded-lg py-3 text-gotham-bold"
					style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;"
				>
					<span class="text-gotham-bold text-white text-16" style="cursor: pointer">
						{{ language == "en" ? "See Order" : "Lihat Order" }}
					</span>
				</button>
		</div>
	</div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {
			title:"",
			description:"",
    };
  },
  beforeMount() {
		this.title = this.language == 'en'?'Rent Cancelled':'Sewa Dibatalkan'
		this.description = this.language == 'en'?'Rental has been cancelled. Thank you for using Paxel, have a nice day!':'Sewa telah dibatalkan, terima kasih telah menggunakan Paxel, semoga harimu menyenangkan!'
	},
	methods: {
	}
}
</script>
